<template>
  <div class="banner">
    <div class="bullet">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <ul id="writter">
      <li><a href="" @click.prevent="handleTabs(1)"></a></li>
      <li><a href="" @click.prevent="handleTabs(2)"></a></li>
      <li><a href="" @click.prevent="handleTabs(3)"></a></li>
    </ul>
  </div>
</template>

<script>
import * as utils from '@/pages/memes2020/index/utils'
import { setCookie } from '@/utils/index'
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../store/mutation-types'
export default {
  computed: {
    is_login() {
      return this.$store.state.base_info.is_logined
    },
    activePage() {
      return this.$store.state.activePage
    },
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    handleTabs(index) {
      switch (index) {
        case 1:
          if (this.activePage == 'WrittenMain') {
            this.$store.state.activePage = 'HomeMain'
            setCookie('active_page', 'HomeMain', 360)
            setTimeout(() => {
              utils.scrollTo('catStory')
            }, 100)
          } else {
            utils.scrollTo('catStory')
          }
          break
        case 2:
          if (this.is_login) {
            setCookie('active_page', 'WrittenMain', 360)
            this.$store.state.activePage = 'WrittenMain'
            // window.location.replace(window.location.href)
          } else {
            setCookie('active_page', 'WrittenMain', 360)
            this.handleLogin()
          }

          break
        case 3:
          this.$store.commit(DIALOG_OPTION, {
            dialogTableVisible: true,
            type: 'RULES',
            data: {},
          })
          break
      }
    },
    handleLogin() {
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: true,
        type: 'EVENTS_LOGIN',
        data: {},
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  height: 919px;
  padding-top: 666px;
  background: url(https://img.dota2.com.cn/file/34/b7/34b76af7afb37ba11d8816a9e558ce5e1597733691.jpg)
    no-repeat center top;
  .bullet {
    position: absolute;
    top: 286px;
    left: 50%;
    margin-left: -633px;
    width: 1266px;
    height: 280px;
    span {
      position: absolute;
      background: url(https://img.dota2.com.cn/file/8b/e0/8be0f6f662631a4098fa1c010521e8dd1597736763.png)
        no-repeat;
      animation: move 3.2s infinite linear;
      width: 200px;
      height: 86px;
      &::before {
        content: '';
        position: absolute;
        width: 16px;
        height: 16px;
        background-image: url('https://img.dota2.com.cn/file/ce/de/cede13e2c29dd9767e2a7d19ce9bcd551597737129.png');
        animation: drive 2s steps(3, end) infinite;
      }
      &:nth-child(1) {
        left: 50px;
        top: 48px;
        background-position: -50px -49px;
        &::before {
          top: 28px;
          left: 42px;
        }
      }
      &:nth-child(2) {
        left: 0px;
        top: 195px;
        background-position: 0px bottom;
        animation-delay: 0.6s;
        &::before {
          top: 43px;
          left: 32px;
          animation-delay: 0.2s;
        }
      }
      &:nth-child(3) {
        left: 720px;
        top: 84px;
        background-position: -720px -84px;
        animation-delay: 0.8s;
        &::before {
          top: 23px;
          left: 32px;
          animation-delay: 0.4s;
        }
      }
      &:nth-child(4) {
        left: 1069px;
        top: 4px;
        width: 120px;
        height: 86px;
        background-position: -1069px -4px;
        animation-delay: 1.2s;
        &::before {
          top: 23px;
          left: 24px;
          animation-delay: 0.6s;
        }
      }
      &:nth-child(5) {
        left: 1069px;
        top: 184px;
        width: 220px;
        background-position: -1050px -184px;
        animation-delay: 0.8s;
        &::before {
          top: 32px;
          left: 32px;
          animation-delay: 0.8s;
        }
      }
    }
  }
  ul {
    width: 1196px;
    height: 237px;
    margin: 0 auto;
    padding: 78px 0 0 62px;
    background-image: url('../assets/btn-bg.png');
    overflow: hidden;
    li {
      float: left;
      a {
        display: block;
        background-repeat: no-repeat;
        &:hover {
          background-position-y: 100%;
        }
      }
      &:nth-child(1) {
        a {
          width: 321px;
          height: 91px;
          background-image: url('../assets/btn-story.png');
        }
      }
      &:nth-child(2) {
        margin: -12px 0 0 -18px;
        a {
          width: 439px;
          height: 115px;
          background-image: url('../assets/btn-creation.png');
        }
      }
      &:nth-child(3) {
        margin-left: -18px;
        a {
          width: 321px;
          height: 91px;
          background-image: url('../assets/btn-rule.png');
        }
      }
    }
  }
}

@keyframes move {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes drive {
  to {
    background-position-x: -48px;
  }
}
</style>
